import DataTableColumnHeader from '@/components/datatable/DataTableColumnHeader.vue';
import EmployeeOptionalsTableActions from '@/components/employee-optionals/EmployeeOptionalsTableActions.vue';
import StatusIndicator from '@/components/StatusIndicator.vue';
import type { EmployeeOptional } from '@/types';
import type { ColumnDef } from '@tanstack/vue-table';
import { h } from 'vue';

export const columns: ColumnDef<EmployeeOptional>[] = [
    {
        accessorKey: 'name',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'employees-optionals.table.name',
            }),
    },
    {
        accessorKey: 'flex_savings',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'employees-optionals.table.flex_savings',
            }),
        cell: ({ row }) => {
            return h(StatusIndicator, {
                active: row.original.flex_savings,
                type: 'yesNo',
            });
        },
        filterFn: 'boolean',
        meta: {
            filterType: 'yesNo',
        },
    },
    {
        accessorKey: 'days_vacation',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'employees-optionals.table.days_vacation',
            }),
        cell: ({ row }) => {
            return h(StatusIndicator, {
                active: row.original.days_vacation,
                type: 'yesNo',
            });
        },
        filterFn: 'boolean',
        meta: {
            filterType: 'yesNo',
        },
    },
    {
        accessorKey: 'production_unit',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'employees-optionals.table.production_unit',
            }),
        cell: ({ row }) => {
            return h(StatusIndicator, {
                active: row.original.production_unit,
                type: 'yesNo',
            });
        },
        filterFn: 'boolean',
        meta: {
            filterType: 'yesNo',
        },
    },

    {
        accessorKey: 'danmarks_statistik',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'employees-optionals.table.danmarks_statistik',
            }),
        cell: ({ row }) => {
            return h(StatusIndicator, {
                active: row.original.danmarks_statistik,
                type: 'yesNo',
            });
        },
        filterFn: 'boolean',
        meta: {
            filterType: 'yesNo',
        },
    },
    {
        accessorKey: 'health_insurance',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'employees-optionals.table.health_insurance',
            }),
        cell: ({ row }) => {
            return h(StatusIndicator, {
                active: row.original.health_insurance,
                type: 'yesNo',
            });
        },
        filterFn: 'boolean',
        meta: {
            filterType: 'yesNo',
        },
    },
    {
        accessorKey: 'has_free_car',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'employees-optionals.table.has_free_car',
            }),
        cell: ({ row }) => {
            return h(StatusIndicator, {
                active: row.original.has_free_car,
                type: 'yesNo',
            });
        },
        filterFn: 'boolean',
        meta: {
            filterType: 'yesNo',
        },
    },
    {
        accessorKey: 'has_free_phone',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'employees-optionals.table.has_free_phone',
            }),
        cell: ({ row }) => {
            return h(StatusIndicator, {
                active: row.original.has_free_phone,
                type: 'yesNo',
            });
        },
        filterFn: 'boolean',
        meta: {
            filterType: 'yesNo',
        },
    },
    {
        accessorKey: 'has_lunch_arrangement',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'employees-optionals.table.has_lunch_arrangement',
            }),
        cell: ({ row }) => {
            return h(StatusIndicator, {
                active: row.original.has_lunch_arrangement,
                type: 'yesNo',
            });
        },
        filterFn: 'boolean',
        meta: {
            filterType: 'yesNo',
        },
    },
    {
        accessorKey: 'has_pension',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'employees-optionals.table.has_pension',
            }),
        cell: ({ row }) => {
            return h(StatusIndicator, {
                active: row.original.has_pension,
                type: 'yesNo',
            });
        },
        filterFn: 'boolean',
        meta: {
            filterType: 'yesNo',
        },
    },
    {
        accessorKey: 'kilometer',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'employees-optionals.table.kilometer',
            }),
        cell: ({ row }) => {
            return h(StatusIndicator, {
                active: row.original.kilometer,
                type: 'yesNo',
            });
        },
        filterFn: 'boolean',
        meta: {
            filterType: 'yesNo',
        },
    },
    {
        accessorKey: 'diaeter',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'employees-optionals.table.diaeter',
            }),
        cell: ({ row }) => {
            return h(StatusIndicator, {
                active: row.original.diaeter,
                type: 'yesNo',
            });
        },
        filterFn: 'boolean',
        meta: {
            filterType: 'yesNo',
        },
    },
    {
        accessorKey: 'has_fixed_add_ons',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'employees-optionals.table.has_fixed_add_ons',
            }),
        cell: ({ row }) => {
            return h(StatusIndicator, {
                active: row.original.has_fixed_add_ons,
                type: 'yesNo',
            });
        },
        filterFn: 'boolean',
        meta: {
            filterType: 'yesNo',
        },
    },
    {
        id: 'actions',
        enableHiding: false,
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'tables.actions',
            }),
        cell: ({ row }) => {
            return h(EmployeeOptionalsTableActions, {
                employeeOptional: row.original,
            });
        },
    },
];
